module.exports = __webpack_public_path__ + "img/Newbie_Shield_01_Mage.06d5b70a.png";